export default "__VITE_ASSET__5d4d15a2__"